export function faqAccordion(containerSelector, questionSelector) {
	const faqs = document.querySelector(containerSelector);

	if (faqs) {
		[...document.querySelectorAll(questionSelector)].forEach(question => {
			gsap.set(question.nextElementSibling, { height: 0 })
			question.addEventListener('click', () => {
				let parent = question.parentElement
				if ('true' === parent.getAttribute('aria-expanded')) {
					parent.setAttribute('aria-expanded', 'false');
					question.classList.remove('expanded');
					gsap.to(question.nextElementSibling, {
						duration: 0.25,
						ease: "power4.in",
						height: 0
					});
				} else {
					parent.setAttribute('aria-expanded', 'true');
					question.classList.add('expanded');
					gsap.to(question.nextElementSibling, {
						duration: 0.25,

						ease: "power4.out",
						height: 'auto'

					});
				}

			});
		})
	}
}